import { Editor as SlateEditor, Element as SlateElement, Transforms } from 'slate';

import { SLATE_TEXT_FORMATS } from 'src/lib/slate';

import { LIST_TYPES } from '../const';
import { isBlockActive, isMarkActive } from '../utils';

export const toggleBlock = (editor, format) => {
  const isList = LIST_TYPES.includes(format);
  const isActive = isBlockActive(editor, format, 'type');

  SlateEditor.withoutNormalizing(editor, () => {
    Transforms.unwrapNodes(editor, {
      match: (n) => SlateElement.isElement(n) && LIST_TYPES.includes(n.type),
      split: true,
    });

    const newProperties = {
      type: isActive
        ? SLATE_TEXT_FORMATS.PARAGRAPH
        : isList
          ? SLATE_TEXT_FORMATS.LIST_ITEM
          : format,
    };
    Transforms.setNodes(editor, newProperties);

    if (!isActive && isList) {
      const block = { type: format, children: [] };
      Transforms.wrapNodes(editor, block);
    }
  });
};

export const toggleTextAlignmentBlock = (editor, format) => {
  const isActive = isBlockActive(editor, format, 'align');

  Transforms.setNodes(editor, {
    align: isActive ? undefined : format,
  });
};

export const toggleMark = (editor, format) => {
  const isActive = isMarkActive(editor, format);

  if (isActive) {
    SlateEditor.removeMark(editor, format);
  } else {
    SlateEditor.addMark(editor, format, true);
  }
};
